export default {"src":"https://fishbrain.com/_next/static/media/premium.cf310558.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};